import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_ENDPOINT } from '../../../config/config';
import '../dashboard_style.css';
import '../dashboard_2025.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';

const SavedRequest = () => {
  const [selectSaved, setSelectSaved] = useState(false);
  const [savedSellCars, setSavedSellCars] = useState([]);
  const [savedBuyCars, setSavedBuyCars] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleChangeSaved = () => setSelectSaved(true);
  const handleChangeSaved1 = () => setSelectSaved(false);

  const getCarLogo = (make) => {
    const logoMap = {
      'suzuki': '/assets/carslogos/suzuki.png',
      'toyota': '/assets/carslogos/toyota.png',
      'honda': '/assets/carslogos/honda.png',
      'kia': '/assets/carslogos/kia.png',
      'nissan': '/assets/carslogos/nissan.png',
      'hyundai': '/assets/carslogos/hyundai.png',
      'bmw': '/assets/carslogos/bmw.png',
      'mercedes': '/assets/carslogos/mercedes.png',
      'audi': '/assets/carslogos/audi.png'
    };
    
    const makeLower = make.toLowerCase();
    return logoMap[makeLower] || '/assets/carslogos/default.png';
  };

  const removeFavorite = async (id, type) => {
    try {
      if (type === 'sell') {
        await axios.delete(`${API_ENDPOINT}/admin/favorite-sell/${id}`);
        setSavedSellCars(savedSellCars.filter(car => car._id !== id));
      } else {
        await axios.delete(`${API_ENDPOINT}/admin/favorite-buy/${id}`);
        setSavedBuyCars(savedBuyCars.filter(car => car._id !== id));
      }
    } catch (error) {
      console.error('Error removing from favorites:', error);
    }
  };

  useEffect(() => {
    const fetchFavorites = async () => {
      setLoading(true);
      try {
        const [sellResponse, buyResponse] = await Promise.all([
          axios.get(`${API_ENDPOINT}/admin/all-favorite-sell`),
          axios.get(`${API_ENDPOINT}/admin/all-favorite-buy`)
        ]);

        setSavedSellCars(sellResponse.data.data.favSellCarsArray || []);
        setSavedBuyCars(buyResponse.data.data.favBuyCarsArray || []);
      } catch (error) {
        console.error('Error fetching favorites:', error);
      }
      setLoading(false);
    };

    fetchFavorites();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
                </div>
    );
  }

  const NoDataMessage = ({ type }) => (
    <div className="no-data-container">
      <img 
        src="/assets/dashboard_images/no-data.svg" 
        alt="No Data" 
        className="no-data-image"
      />
      <h3>No Saved {type}</h3>
      <p>You haven't saved any {type.toLowerCase()} yet.</p>
    </div>
  );

  return (
    <div className="saved-cars-container">
      <div className="tab-navigation">
        <button 
          className={!selectSaved ? 'tab-button active' : 'tab-button'} 
          onClick={handleChangeSaved1}
        >
          <span className="tab-text">Saved Sales</span>
          <span className="tab-count">{savedSellCars.length}</span>
        </button>
        <button 
          className={selectSaved ? 'tab-button active' : 'tab-button'} 
          onClick={handleChangeSaved}
        >
          <span className="tab-text">Saved Purchases</span>
          <span className="tab-count">{savedBuyCars.length}</span>
                              </button>
                            </div>
                         
        <div className="cars-container">
          {!selectSaved ? (
          savedSellCars.length === 0 ? (
            <NoDataMessage type="Sales" />
          ) : (
            savedSellCars
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((car) => (
                <div key={car._id} className="car-card-wrapper">
                  <Link to={`/saledetail/${car._id}`} style={{ textDecoration: 'none' }}>
                  <div className="car-card">
                    <div className="car-header">
                      <div className="car-brand">
                        <div className="logo-container">
                          <img 
                            src={getCarLogo(car.make.make)}
                            alt={car.make.make}
                            className="brand-logo"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = '/assets/carslogos/default.png';
                            }}
                          />
                        </div>
                        <div className="car-title">
                          <h2>{car.make.make} {car.make.model} {car.make.year}</h2>
                          <span className="car-variant">{car.make.version}</span>
                                      </div>
                                  </div>
                              </div>

                    <div className="car-info-grid">
                      <div className="info-item">
                        <div className="info-icon">
                          <i className="fa fa-tachometer"></i>
                              </div>
                        <div className="info-content">
                          <span className="info-value">{car.milage}</span>
                          <span className="info-label">KM</span>
                          </div>
                      </div>
                      
                      <div className="info-item">
                        <div className="info-icon">
                          <i className="fa fa-gear"></i>
                                          </div>
                        <div className="info-content">
                          <span className="info-value">{car.transmission}</span>
                          <span className="info-label">TRANSMISSION</span>
                                      </div>
                                  </div>

                      <div className="info-item">
                        <div className="info-icon">
                          <i className="fa fa-palette"></i>
                        </div>
                        <div className="info-content">
                          <span className="info-value">{car.exteriorColor}</span>
                          <span className="info-label">COLOR</span>
                                  </div>
                              </div>
                    </div>

                    <div className="car-footer">
                      <div className="location-date">
                        <div className="location">
                          <i className="fa fa-map-marker"></i>
                          <span>{car.registerCity}</span>
                        </div>
                        <div className="date">
                          <i className="fa fa-calendar"></i>
                          <span>{new Date(car.date).toLocaleDateString()}</span>
                          </div>
                      </div>
                      {car.priority === "High" && (
                        <div className="price-tag">HIGHEST PRICE</div>
                      )}
                      </div>
                  </div>
                </Link>
                  <button 
                    className="remove-favorite-button" 
                    onClick={() => removeFavorite(car._id, 'sell')}
                  >
                    <FontAwesomeIcon icon={faHeart} />
                    Remove from Favorites
                  </button>
                </div>
              ))
          )
        ) : (
          savedBuyCars.length === 0 ? (
            <NoDataMessage type="Purchases" />
          ) : (
            savedBuyCars
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((car) => (
                <div key={car._id} className="car-card-wrapper">
                  <Link to={`/buydetail/${car._id}`} style={{ textDecoration: 'none' }}>
                    <div className="car-card">
                      <div className="car-header">
                        <div className="car-brand">
                          <div className="logo-container">
                            <img 
                              src={getCarLogo(car.make.make)}
                              alt={car.make.make}
                              className="brand-logo"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = '/assets/carslogos/default.png';
                              }}
                            />
                          </div>
                          <div className="car-title">
                            <h2>{car.make.make} {car.make.model} {car.from}-{car.to}</h2>
                            <span className="car-variant">{car.make.version}</span>
                          </div>
                        </div>
                      </div>

                      <div className="car-info-grid">
                        <div className="info-item">
                          <div className="info-icon">
                            <i className="fa fa-money"></i>
                          </div>
                          <div className="info-content">
                            <span className="info-value">{car.minBudget} - {car.maxBudget}</span>
                            <span className="info-label">BUDGET (PKR)</span>
                          </div>
                        </div>

                        <div className="info-item">
                          <div className="info-icon">
                            <i className="fa fa-gear"></i>
                          </div>
                          <div className="info-content">
                            <span className="info-value">{car.transmission}</span>
                            <span className="info-label">TRANSMISSION</span>
                          </div>
                        </div>

                        <div className="info-item">
                          <div className="info-icon">
                            <i className="fa fa-palette"></i>
                          </div>
                          <div className="info-content">
                            <span className="info-value">{car.exteriorColor.join(', ')}</span>
                            <span className="info-label">COLOR</span>
                          </div>
                        </div>
                      </div>

                      <div className="car-footer">
                        <div className="location-date">
                          <div className="location">
                            <i className="fa fa-map-marker"></i>
                            <span>{car.city}</span>
                          </div>
                          <div className="date">
                            <i className="fa fa-calendar"></i>
                            <span>{new Date(car.date).toLocaleDateString()}</span>
                          </div>
            </div>
                        {car.urgency === "High" && (
                          <div className="price-tag">URGENT</div>
          )}
        </div>
                    </div>
                  </Link>
                  <button 
                    className="remove-favorite-button" 
                    onClick={() => removeFavorite(car._id, 'buy')}
                  >
                    <FontAwesomeIcon icon={faHeart} />
                    Remove from Favorites
                  </button>
                </div>
              ))
          )
        )}
      </div>

      <style jsx>{`
        .saved-cars-container {
          padding: 20px;
          max-width: 1400px;
          margin: 0 auto;
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 300px;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #f3f3f3;
          border-top: 4px solid #d9534f;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .no-data-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 50px 20px;
          text-align: center;
          width: 100%;
          grid-column: 1 / -1;
        }

        .no-data-image {
          width: 200px;
          margin-bottom: 20px;
        }

        .tab-navigation {
          display: flex;
          gap: 16px;
          margin-bottom: 32px;
          border-bottom: 1px solid #eee;
          padding-bottom: 8px;
        }

        .tab-button {
          display: flex;
          align-items: center;
          gap: 8px;
          background: none;
          border: none;
          padding: 8px 16px;
          color: #666;
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          position: relative;
        }

        .tab-button:after {
          content: '';
          position: absolute;
          bottom: -9px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #d9534f;
          transform: scaleX(0);
          transition: transform 0.2s ease;
        }

        .tab-button.active {
          color: #333;
        }

        .tab-button.active:after {
          transform: scaleX(1);
        }

        .tab-count {
          background: #f8f9fa;
          color: #666;
          padding: 2px 8px;
          border-radius: 20px;
          font-size: 13px;
          min-width: 28px;
          text-align: center;
        }

        .tab-button.active .tab-count {
          background: #d9534f;
          color: white;
        }

        .cars-container {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
          padding: 20px 0;
        }

        .car-card-wrapper {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .car-card {
          background: white;
          border-radius: 10px;
          padding: 16px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
          border: 1px solid #eee;
          height: 100%;
        }

        .car-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          border-color: #d9534f;
        }

        .remove-favorite-button {
          width: 100%;
          padding: 10px;
          background: #d9534f;
          color: white;
          border: none;
          border-radius: 8px;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.2s ease;
        }

        .remove-favorite-button:hover {
          background: #c9302c;
          transform: translateY(-1px);
        }

        .remove-favorite-button svg {
          font-size: 1.1rem;
        }

        .logo-container {
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: white;
          border-radius: 8px;
          padding: 6px;
          border: 1px solid #eee;
        }

        .brand-logo {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .car-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 16px;
        }

        .car-brand {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .car-title h2 {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin: 0;
          line-height: 1.2;
        }

        .car-variant {
          font-size: 13px;
          color: #666;
          display: block;
          margin-top: 2px;
        }

        .car-info-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          padding: 12px 0;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          margin: 12px 0;
        }

        .info-item {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .info-icon {
          width: 32px;
          height: 32px;
          background: #fff1f1;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .info-icon i {
          color: #d9534f;
          font-size: 16px;
        }

        .info-content {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .info-value {
          font-size: 14px;
          font-weight: 500;
          color: #333;
        }

        .info-label {
          font-size: 10px;
          color: #666;
          font-weight: 500;
          letter-spacing: 0.5px;
        }

        .car-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;
        }

        .location-date {
          display: flex;
          gap: 16px;
          font-size: 13px;
          color: #666;
        }

        .location, .date {
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .location i, .date i {
          color: #d9534f;
          font-size: 14px;
        }

        .price-tag {
          background: #d9534f;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.5px;
        }

        @media (max-width: 1200px) {
          .cars-container {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .cars-container {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default SavedRequest;